import type { DriverType } from '@repo/supergraph/marketplace/types';
import { TERM_LENGTH_FORMAT } from '@repo/utils/cdTerm/constants';
import { formatLabel } from '@repo/utils/cdTerm/formatLabel';
import { Driver } from './Driver';

export const Drivers = ({
  cdDepositTerm,
  driverApy,
  driverMinimumBalance,
}: {
  cdDepositTerm?: number;
  driverApy?: DriverType;
  driverMinimumBalance?: DriverType;
}) => {
  return (
    <>
      <Driver label="APY" value={driverApy?.value} tooltip={driverApy?.valueTooltip} />
      <Driver label="Minimum deposit" value={driverMinimumBalance?.value} />
      <Driver
        label="Term"
        value={formatLabel({
          cdDepositTerm,
          format: TERM_LENGTH_FORMAT.abv,
        })}
      />
    </>
  );
};
